"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $parse;
var $interpolate;
var $injector = angular.injector(['ng']);
var customParseFunctions = {
    toInt: function (input) {
        var int = parseInt(input, 10);
        return isNaN(int) ? input : int;
    },
    importName: function (input, length, pattern) {
        if (!input) {
            return '';
        }
        if (pattern) {
            var regexp = new RegExp(pattern, 'g');
            input = regexp.test(input) ? '' : input;
        }
        if (length && input.length > length) {
            input = '';
        }
        return input;
    }
};
function extendContext(context) {
    if (!context.$) {
        Object.defineProperty(context, '$', {
            enumerable: false,
            value: customParseFunctions
        });
    }
    return context;
}
$injector.invoke(['$parse', function (_$parse_) {
        $parse = _$parse_;
    }]);
$injector.invoke(['$interpolate', function (_$interpolate_) {
        $interpolate = _$interpolate_;
    }]);
function interpolate(string, context) {
    context = extendContext(context);
    return $interpolate(string)(context);
}
exports.interpolate = interpolate;
function evaluateCondition(condition, context) {
    var expression = $parse(condition);
    context = extendContext(context);
    return expression(context);
}
exports.evaluateCondition = evaluateCondition;
function evaluateOptions(options, context) {
    options = Array.isArray(options) ? options : [options];
    for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
        var option = options_1[_i];
        if (typeof option.$condition !== 'string') {
            return;
        }
        option.condition = evaluateCondition(option.$condition, context);
    }
}
exports.evaluateOptions = evaluateOptions;
function filterOptions(options) {
    function conditionFilter(option) {
        return option.condition === true;
    }
    return options.filter(conditionFilter);
}
exports.filterOptions = filterOptions;
exports.default = $parse;
